import axios from "axios";
import { axiosWithKey } from '~/axios'
import { getToken} from '~/redux/user/tokens'


export const getPresignedUrl = (userId) => {
    return getToken().then(token => {
       return axiosWithKey.get('/user/me/presign-url',
            {
              params:{
              userId:userId
            },
            headers:{
              Authorization: token
            }
          })
          .then(response => response.data);
    });
}

export const getUserQuestions = (userId) => {
    return getToken().then(token => {
        return axiosWithKey.get('/fitness/questions',
            {
              params:{
                  userId:userId,
                  site: window.settings.internalName
                },
            headers:{
              Authorization: token
            }
          })
      })
      .then(response => response.data)
      .then(response => response.Items);
}

export const getUserProfile = (userId) => {
    return getToken().then(token => {
        return axiosWithKey.get('/user/me',
            {
              params:{
              userId:userId
            },
            headers:{
              Authorization: token
            }
          })
      })
    .then(response => response.data);
}


export const updateUserProfile = (profile,userId) => {

    let params = Object.assign(profile,{
        userId
      });

    params.interests = profile.interests.map( i => {
      if(i.gist){
        return {contentId: i.gist.id};
      } else if (i.contentId) {
        return {contentId: i.contentId};
      }
    });

    return getToken().then(token => {
        return axiosWithKey.put('/user/me/description',params,
            {
              headers:{
                Authorization: token
            }
          })
      })
      .then(response => response.data)
}

export const postImage = (url,file) => {
    const options = {
      headers: {
        'Content-Type': 'application/octet-stream'
      }
    };
    
    return axios.put(url,file,options)
      .then(result  => result);
}

export const getUserAchievements = (userId) => {
  return getToken().then(token => {
    return axiosWithKey.get('/user/achievements',
      {
        params:{
          userId: 'c3476430-1998-11e9-ada1-27f21cfb2597'
        },
        headers:{
          Authorization: token
        }
      });
  });
}